var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ids-corpora-filter px-2"},_vm._l((_vm.corpusByCategory),function(corpusItems,name){return _c('ids-corpus-category',{key:name,attrs:{"corpusCategoryName":name,"corpusItems":corpusItems,"selection":_vm.dataCorpusSelection[name]},on:{"ids-corpus-selection-change":_vm.onCorpusSelectionChange}})}),1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36a3857d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ids/components/filter/IdsCorporaFilter.vue
// module id = c8A0
// module chunks = 1